import { Image } from "react-bootstrap";
import { Calendar, MapPin } from "react-feather";
import { formatDate, formatNumberWithout } from "../helper";
import { useNavigate } from "react-router-dom";

const CardEvent = (props) => {
  const navigate = useNavigate();
  const event = props?.item?.[0];

  const getLowestFPrice = () => {
    const data = event?.tickets;

    if (!Array.isArray(data) || data.length === 0) return null;

    const validPrices = data.filter((item) => item.f_price > 0);

    if (validPrices.length === 0) return null;

    const lowest = validPrices.reduce((min, item) => {
      return item.f_price < min.f_price ? item : min;
    });

    return lowest.f_price;
  };

  const handleGotoEventDetail = () => {
    navigate(`/event/${event?.information?.slug}`, {
      state: event,
    });
  };

  return (
    <div className="event-card" onClick={handleGotoEventDetail}>
      <Image
        src={`${process.env.REACT_APP_API_URL_IMAGE}${event?.thumbnail}`}
        className="event-card-thumb"
        alt={event?.information?.title || "event"}
      />
      <div className="event-card-body">
        <div>
          <h6 className="event-card-title">
            {event?.information?.title || ""}
          </h6>
          <div className="event-card-meta">
            <Calendar size={13} />
            {formatDate(event?.start_date || "")} •{" "}
            {(event?.start_time || "").replace(":", ".")}
          </div>
          <div className="event-card-meta">
            <MapPin size={13} />
            {event?.information?.address}
          </div>
        </div>
        <div className="event-card-price">
          Mulai dari
          <strong>Rp{formatNumberWithout(getLowestFPrice())}</strong>
        </div>
      </div>
    </div>
  );
};

export default CardEvent;
